import { reactive } from "vue";

export const filterStore = reactive({
    sorting: null,
    order: null,
    name: null,
    projectStatuses: [],
    interestRateType: null,
    noProxy: null,
    interestRateFrom: null,
    interestRateTo: null,
    initialTermFrom: null,
    initialTermTo: null,
    loanAmountFrom: null,
    loanAmountTo: null,
});